import React from 'react'
import { PropTypes } from 'prop-types'
import ReactPaginate from 'react-paginate'
var clamp = window.$clamp

class ResourceList extends React.Component{
	render(){
		let content = <div className="resource-card-collection-wrapper" dangerouslySetInnerHTML={{__html: this.props.content}} />;

		let afterListing = null;
		if(this.props.isLoading){
			content = <div className="loading-throbber"><span className="text">Loading...</span><div className="cssload-ball" /></div>
		} else if(this.props.totalPages > 1){

			afterListing = <ReactPaginate previousLabel={<i className="icon icon-arrow-down" data-grunticon-embed />}
				                     nextLabel={<i className="icon icon-arrow-down" data-grunticon-embed />}
				                     breakLabel={'…'}
				                     breakClassName={"break-me"}
				                     forceSelected={this.props.page - 1}
				                     pageNum={this.props.totalPages}
				                     marginPagesDisplayed={1}
				                     pageRangeDisplayed={3}
				                     clickCallback={this.props.onClickPage}
				                     containerClassName={"pagination"}
				                     subContainerClassName={"pages pagination"}
				                     activeClassName={"active"} />;
		}

		return (
			<div className="container">
				{ content }
				{ afterListing }
			</div>
		)
	}

	componentDidUpdate(prevProps, prevState) {
		if(clamp){
			let cards = document.querySelectorAll('.resource-card');
			for(let card of cards){
				let title = card.querySelector('.title');
				clamp(title, { clamp: 'auto' });
			}
		}

		if(window.grunticon){
			window.grunticon.embedSVG();
		}
	}
}

ResourceList.propTypes = {
	isLoading: PropTypes.bool,
	content: PropTypes.string,
	page: PropTypes.number,
	totalPages: PropTypes.number,
	onClickPage: PropTypes.func
}

export default ResourceList



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/resource-grid/components/resource-list.js